import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, pluck, startWith, switchMap, tap } from 'rxjs/operators';
import { RestService } from '../../../../services/rest-service.service';

@Component({
  selector: 'sc-field-search',
  templateUrl: './field-search.component.html',
  styleUrls: ['./field-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldSearchComponent extends FieldType implements OnInit, OnDestroy {
  defaultOptions = {
    templateOptions: {
      hideFieldUnderline: true,
      indeterminate: false,
      floatLabel: 'always',
      hideLabel: true,
      align: 'start',
      color: 'accent'
    }
  };

  public label: string;

  public filteredEntities: Observable<any[]>;
  private _loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _reset$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private _restService: RestService) {
    super();
  }

  public loading() {
    return this._loading.asObservable();
  }

  public selectFilter(searchFilter) {
    this.formControl.setValue(null);
    this.to.config.default = searchFilter;
    if (this.to.config.default.label) {
      this.to.label = this.to.config.default.label;
    }
    this._reset$.next(true);
  }

  public ngOnInit() {
    if (!this.to.config) {
      console.warn('AbleraSearchConfig is missing!');
      return;
    }

    if (this.to.config.default.label) {
      this.to.label = this.to.config.default.label;
    }

    this.filteredEntities = combineLatest(
      this.formControl.valueChanges.pipe(startWith(this.formControl.value)),
      this._reset$.asObservable()
    ).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(([value, reset]) => reset || typeof value === 'string'),
      switchMap(([value, reset]) => {
        if (reset) {
          this._reset$.next(false);
          return of([]);
        }

        this._loading.next(true);
        const { filterBy, endpoint, filters } = this.to.config.default;
        return this._restService
          .post<any[]>(endpoint, {
            filters: [
              {
                prop: filterBy,
                comparison: 'contains',
                value: this.to.uppercase ? value.toUpperCase() : value
              },
              ...filters
            ]
          })
          .pipe(pluck('items'));
      }),
      tap((values: any[]) => {
        this._loading.next(false);
        if (values.length === 1 && this.model.id) {
          this.formControl.setValue(values[0]);
        }
      })
    );
  }

  public ngOnDestroy() {}
}
